<template lang="pug">
.d-main-image
  transition( name='fade' )
    img.main-bg( v-if='img' :src='img' v-show='show' v-on='$listeners' )
</template>

<script lang="js">

export default {
  name: 'MainImageDisplay',
  mixins: [],
  components: {},
  props: {
    img: String,
    show: Boolean,
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.d-main-image {
  position: absolute;
  width: 100vw;
  overflow: hidden;
  height: 100vh;
  left: 0;
  top: 0;
  background: #100;
  transform: translateZ(-2px) scale(2.02);
  > .main-bg, > .main-bg-new {
    position: absolute;
    min-width: 100vw;
    min-height: 100vh;
    max-width: none;
    transform: translateZ(-2px) scale(2.02);
    height: 100vh;
    @include for-mobile {
      min-height: 100vh;
      max-width: none;
    }
  }
  .main-bg-new {
    display: none
  }
}
</style>
